import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { Col, Input, Label, Row } from "reactstrap";
import LiveLocationMap from "../../../../components/LiveLocationMap";
import {
  useGetCartDetailsByIdQuery,
  useUpdateCartDetailsMutation,
  useUpdateCartImageMutation,
  useUpdateCartStatusMutation,
  useUpdateCartStatusOnlineMutation,
  useUploadCartLogoFileExtntionHttpsMutation,
  useLazyGetAllCartDetailsQuery,
} from "../../../../redux/services/cartSearchService";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faClose,
  faCopy,
  faEdit,
  faFloppyDisk,
  faMapMarkerAlt,
  faQuestion,
  faSpinner,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import ButtonComponent from "../../../../components/ButtonComponent";
import { useEffect, useState, useMemo, useCallback } from "react";
import { toast } from "react-toastify";
import { uploadImage } from "../../../../components/imageUploadCompont";
import { formatTimestamp } from "../../../../utility/Utility";
import ButtonComponentV2 from "../../../../components/ButtonComponentV2";
import { useSelector } from "react-redux";
import EditButtonComponent from "../../../../components/EditButtonComponent";
import {
  CART_TYPE,
  CartTypeOption,
  ChannelOption,
  REASONS_FOR_GO_OFFLINE,
  SUPPORTED_CHANNELS_OPTIONS,
} from "../../../../constants/constans";
import ControlledSelect from "../../../../components/ControlledSelect";
import ControlledRowTextFieldAddress from "../../../../components/ControlledRowTextFieldAddress";
import ControlledRowTextField from "../../../../components/ControlledRowTextField";
import { useForm, Controller } from "react-hook-form";
import Map from "../../../../components/LocationSelectorModal";
import EditPhotoUpload from "../../../../components/EditPhotoUpload";

export type CartStatusData = {
  cartStatus: { value: string; label: string };
};
interface CartOption {
  value: string;
  label: string;
  isFixedLocation: boolean;
  displayName?: string;
}

const CartDetails = () => {
  const navigate = useNavigate();

  const cart = useSelector((state: any) => state?.cart?.selectedCart);
  const cartId = cart.id || cart.cartId;

  const [showModal, setShowModal] = useState(false);
  const [mapShowModal, setMapShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalOffline, setShowModalOffline] = useState(false);
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true);
  const [isImageUpdateLoading, setIsImageUpdateLoading] = useState(false);
  const [showStatusUpdateModal, setshowStatusUpdateModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [otherReasonText, setOtherReasonText] = useState("");
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [selectedLocation, setSelectedLocation] = useState({
    latitude: 28.7041,
    longitude: 77.1025,
  });
  const [deliveryCartOptions, setDeliveryCartOptions] = useState<CartOption[]>(
    [],
  );
  const [isLoadingDeliveryCarts, setIsLoadingDeliveryCarts] = useState(false);
  const [deliveryCartNames, setDeliveryCartNames] = useState<string[]>([]);
  const [getAllCartDetails, { data: allCartsData, isLoading: isCartsLoading }] =
    useLazyGetAllCartDetailsQuery();

  const {
    data: cartData,
    isLoading: isFetching,
    refetch: refetchCartDetails,
  } = useGetCartDetailsByIdQuery(cartId);
  const [clickedButton, setClickedButton] = useState<string | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [showAssigned, setShowAssigned] = useState<boolean>(() => {
    const savedState = localStorage.getItem("showAssigned");
    return savedState ? JSON.parse(savedState) : false;
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm<{
    displayName: string;
    abbreviation: string;
    cartType: CartTypeOption | null;
    address: string;
    latitude: number;
    longitude: number;
    supportedChannels: ChannelOption[];
    deliveryCartsIds: CartOption[];
  }>({
    defaultValues: {
      displayName: cart?.displayName || "",
      abbreviation: cart?.abbreviation || "",
      cartType: null,
      address: cart?.address || "",
      latitude: cart?.location?._latitude || 0,
      longitude: cart?.location?._longitude || 0,
      supportedChannels: [],
      deliveryCartsIds: [],
    },
  });

  const cartType = watch("cartType");
  const selectedDeliveryCartsIds = watch("deliveryCartsIds");

  const isFixedCart = useMemo(() => {
    if (cartType) {
      if (cartType.value && typeof cartType.value === "object") {
        return (
          cartType.value.type?.toLowerCase() === "fixed" ||
          cartType.value.isFixedLocation === true
        );
      } else if (typeof cartType.value === "string") {
        return cartType.value === "fixed";
      }
      return cartType.label?.toLowerCase() === "fixed";
    }

    // If cartType is null/empty, return false
    return false;
  }, [cartType]);

  const getCartNamesByIds = useCallback(
    (cartIds: string[], allCarts: any[]): string[] => {
      if (!cartIds || cartIds.length === 0) return [];

      const cartNames: string[] = [];

      cartIds.forEach((id) => {
        const cart = allCarts.find(
          (c: any) => c.id === id || c.cartId === id || c.value === id,
        );
        if (cart) {
          cartNames.push(
            cart.displayName ||
              cart.name ||
              cart.label ||
              `Cart ${id.substring(0, 8)}`,
          );
        } else {
          cartNames.push(`Cart ${id.substring(0, 8)}`);
        }
      });

      return cartNames;
    },
    [],
  );

  useEffect(() => {
    const fetchAllCarts = async () => {
      if (!isEditMode && cartType?.value?.type === "fixed") {
        try {
          await getAllCartDetails(undefined).unwrap();
        } catch (error) {
          console.error("Failed to fetch all carts:", error);
        }
      }
    };

    fetchAllCarts();
  }, [isEditMode, cartType, getAllCartDetails]);

  useEffect(() => {
    const handleCartTypeChange = async () => {
      if (!isEditMode) {
        // Only fetch delivery carts if cartType is explicitly set to fixed
        if (cartType?.value?.type === "fixed") {
          setIsLoadingDeliveryCarts(true);
          try {
            if (!allCartsData) {
              await getAllCartDetails(undefined).unwrap();
            }
          } catch (error) {
            console.error("Failed to fetch carts:", error);
          } finally {
            setIsLoadingDeliveryCarts(false);
          }
        } else {
          setValue("deliveryCartsIds", []);
          setDeliveryCartOptions([]);
        }
      }
    };

    handleCartTypeChange();
  }, [cartType, isEditMode, allCartsData, getAllCartDetails, setValue]);

  useEffect(() => {
    if (allCartsData && cartType?.value?.type === "fixed" && !isEditMode) {
      try {
        let carts = allCartsData;

        if (allCartsData.items && Array.isArray(allCartsData.items)) {
          carts = allCartsData.items;
        } else if (Array.isArray(allCartsData)) {
          carts = allCartsData;
        }

        // Update this filter to check both conditions
        const deliveryCarts = carts.filter(
          (cart: any) =>
            cart.isFixedLocation === false &&
            cart.id !== cartId &&
            cart.cartType?.toLowerCase() === "delivery",
        );

        const options = deliveryCarts.map((cart: any) => ({
          value: cart.id || cart.cartId,
          label:
            cart.displayName ||
            cart.name ||
            `Cart ${cart.id?.substring(0, 8) || "Unnamed"}`,
          displayName:
            cart.displayName || cart.name || `Cart ${cart.id?.substring(0, 8)}`,
          isFixedLocation: cart.isFixedLocation || false,
          cartType: cart.cartType || "delivery",
        }));

        setDeliveryCartOptions(options);

        if (
          cartData?.deliveryCartsIds &&
          Array.isArray(cartData.deliveryCartsIds)
        ) {
          const selectedOptions = options.filter((option: CartOption) =>
            cartData.deliveryCartsIds.includes(option.value),
          );
          setValue("deliveryCartsIds", selectedOptions);
        }
      } catch (error) {
        console.error("Error processing cart data:", error);
        setDeliveryCartOptions([]);
      }
    }
  }, [allCartsData, cartType, isEditMode, cartId, cartData, setValue]);
  useEffect(() => {
    if (
      isEditMode &&
      cartType?.value?.type === "fixed" &&
      cartData &&
      allCartsData
    ) {
      const cartIds =
        cartData.deliveryCartsIds || cartData.deliveryCartIds || [];
      if (cartIds.length > 0) {
        let allCarts = allCartsData;

        if (allCartsData.items && Array.isArray(allCartsData.items)) {
          allCarts = allCartsData.items;
        } else if (Array.isArray(allCartsData)) {
          allCarts = allCartsData;
        }

        const names = getCartNamesByIds(cartIds, allCarts);
        setDeliveryCartNames(names);
      } else {
        setDeliveryCartNames([]);
      }
    }
  }, [isEditMode, cartType, cartData, allCartsData, getCartNamesByIds]);

  const handleUpdatePhoto = () => {
    setShowModal(true);
  };

  const [updateCartDetails] = useUpdateCartDetailsMutation();

  const handleOffline = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowModalOffline(true);
  };

  const handleCloseOfflineModal = () => {
    setShowModalOffline(false);
  };

  const [getCartImageReference] = useUploadCartLogoFileExtntionHttpsMutation();
  const [updateCartImage] = useUpdateCartImageMutation();

  // Photo Upload
  const [uploadedImgDetails, setUploadedImgDetails] = useState<{
    imgSrc: string;
    formData: any;
    fileExtention: string;
  }>({
    imgSrc: "",
    formData: "",
    fileExtention: "",
  });

  const imageUploadCallback = (e: any) => {
    setUploadedImgDetails({
      ...uploadedImgDetails,
      imgSrc: e.imgSrc,
      formData: e.formData,
      fileExtention: e.fileExtension,
    });
    setIsSaveButtonDisabled(false);
  };

  const handleCartImageUpdate = async () => {
    setIsImageUpdateLoading(true);
    const imageRef = await uploadImage(getCartImageReference, {
      fileExtention: uploadedImgDetails.fileExtention,
      formData: uploadedImgDetails.formData,
    });
    const updateImageResponse = await updateCartImage({
      imgRef: imageRef,
      cartId: cartId,
    });
    if ("data" in updateImageResponse) {
      toast.success("Cart Image Successfully Updated");
      refetchCartDetails();
      handleCloseModal();
    } else {
      toast.error("Something Went Wrong");
    }
    setIsImageUpdateLoading(false);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setIsSaveButtonDisabled(true);
    setUploadedImgDetails({ imgSrc: "", formData: "", fileExtention: "" });
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleLocationModalClose = () => {
    setMapShowModal(false);
  };

  const handleLocationSave = (
    latitude: number,
    longitude: number,
    address: string,
  ) => {
    setSelectedLocation({ latitude: latitude, longitude: longitude });
    setValue("latitude", latitude);
    setValue("longitude", longitude);
    setValue("address", address);
  };

  const handleStatusUpdateShowModal = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (showAssigned) {
      e.stopPropagation();
      setshowStatusUpdateModal(true);
    } else {
      toast.warning(
        <div>
          <strong>You can't change Cart Status...!</strong>
          <hr />
          <small style={{ textAlign: "center", display: "block" }}>
            Before, You have to assign Cart Person...!
          </small>
        </div>,
      );
    }
  };

  const handleCloseStatusUpdateModal = () => {
    setshowStatusUpdateModal(false);
  };

  const handleInputCartOnlineChange = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSelectedReason(e.target.value);
    if (e.target.value !== "Other") {
      setOtherReasonText("");
    }
  };

  const [updateCartStatusOnline] = useUpdateCartStatusOnlineMutation();

  const handleUpdateCartStatusOnline = () => {
    const finalReason =
      selectedReason === "Other" ? otherReasonText.trim() : selectedReason;

    if (!finalReason) {
      toast.error("Please select a reason before going offline.");
      return;
    }

    updateCartStatusOnline({
      cartId: cartId,
      cartState: "Offline",
      reasonForBeingOffline: finalReason,
    });

    toast.success("Cart status updated to Offline");
    setShowModalOffline(false);
    refetchCartDetails();
  };

  const handleUpdateCartStatusBackOnline = () => {
    updateCartStatusOnline({
      cartId: cartId,
      cartState: "Online",
      reasonForBeingOffline: "",
    });
    toast.success("Cart status updated to Online");
    refetchCartDetails();
  };

  const handleUpdateCartStatusOntheWay = () => {
    updateCartStatusOnline({
      cartId: cartId,
      cartState: "OnTheWay",
      reasonForBeingOffline: "",
    });
    toast.success("Cart status updated to On The Way");
    refetchCartDetails();
  };

  const [triggerUpdateCartList, { isLoading: isCartStautsUpdating }] =
    useUpdateCartStatusMutation();

  const handleStatusUpdate = async (status: string, buttonType: string) => {
    setClickedButton(buttonType);
    const obj = {
      cartId: cartId,
      cartStatus: status,
    };

    const response: any = await triggerUpdateCartList(obj);
    if (response.data === "OK") {
      if (status === "Deleted") {
        toast.success("Cart deleted successfully");
        navigate("/carts/carts-list");
      } else {
        toast.success("Cart Status Updated");
        setshowStatusUpdateModal(false);
        refetchCartDetails();
      }
    } else {
      toast.error("Cart Status Could not be updated");
    }
    setClickedButton(null);
  };

  const handleCopyToClipboard = () => {
    if (cartData?.id) {
      navigator.clipboard.writeText(cartData.id);
      toast.success("Cart ID copied to clipboard!");
    }
  };

  const handleEdit = () => {
    setIsEditMode(!isEditMode);
  };
const onSubmit = async (data: any) => {
  setIsLoading(true);

  const supportedChannelsValues = data.supportedChannels
    ? data.supportedChannels.map((channel: ChannelOption) => channel.value)
    : [];

  const deliveryCartsIds =
    cartType?.value?.type === "fixed" && data.deliveryCartsIds
      ? data.deliveryCartsIds.map((cart: CartOption) => cart.value)
      : [];

    // Get the cart type and capitalize the first letter
    let cartTypeValue = data.cartType?.value?.type || "delivery";

    // Capitalize first letter of cart type
    if (cartTypeValue) {
      cartTypeValue =
        cartTypeValue.charAt(0).toUpperCase() +
        cartTypeValue.slice(1).toLowerCase();
    }

    const isFixedLocation = data.cartType?.value?.type === "fixed" || false;

    const updatePayload: any = {
      cartId,
      displayName: data.displayName,
      abbreviation: data.abbreviation || "",
      cartLocation: {
        latitude: parseFloat(data.latitude),
        longitude: parseFloat(data.longitude),
      },
      address: data.address,
      isFixedLocation: isFixedLocation,
      supportedChannels: supportedChannelsValues,
      cartType: cartTypeValue, 
    };

    if (isFixedLocation) {
      updatePayload.deliveryCartsIds = deliveryCartsIds;
    } else {
      updatePayload.deliveryCartsIds = [];
    }

  try {
    const response: any = await updateCartDetails(updatePayload);
    setIsLoading(false);

      if (response.error) {
        toast.error("Failed to update cart details");
        console.error("Update error:", response.error);
      } else {
        toast.success("Cart details updated successfully");
        setIsEditMode(true);
        refetchCartDetails();
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("Failed to update cart details");
      console.error("Update error:", error);
    }
  };
  useEffect(() => {
    if (cartData) {
      setValue("displayName", cartData.displayName || "");
      setValue("abbreviation", cartData.abbreviation || "");

      const cartTypeValue = cartData.cartType || cartData.type;
      // const isFixedLocation = cartData.isFixedLocation;

      // console.log("Cart data:", {
      //   cartType: cartTypeValue,
      //   type: cartData.type,
      //   isFixedLocation: isFixedLocation,
      //   hasCartType: !!cartTypeValue,
      //   hasType: !!cartData.type,
      // });

      let cartTypeOption: CartTypeOption | null = null;

      if (cartTypeValue) {
        const normalizedCartType = cartTypeValue
          .toString()
          .toLowerCase()
          .trim();

        // console.log("Cart type from API:", normalizedCartType);

        // Find matching cart type option
        const foundOption = CART_TYPE.find((option) => {
          if (option.value && typeof option.value === "object") {
            return option.value.type.toLowerCase() === normalizedCartType;
          }
          return false;
        });

        if (foundOption) {
          cartTypeOption = foundOption;
        } else {
          // Try to find by label as fallback
          if (normalizedCartType === "fixed") {
            const fixedOption = CART_TYPE.find(
              (opt) =>
                opt.value?.type?.toLowerCase() === "fixed" ||
                opt.label.toLowerCase() === "fixed",
            );
            if (fixedOption) cartTypeOption = fixedOption;
          } else if (normalizedCartType === "moving") {
            const movingOption = CART_TYPE.find(
              (opt) =>
                opt.value?.type?.toLowerCase() === "moving" ||
                opt.label.toLowerCase() === "moving",
            );
            if (movingOption) cartTypeOption = movingOption;
          } else if (normalizedCartType === "delivery") {
            const deliveryOption = CART_TYPE.find(
              (opt) =>
                opt.value?.type?.toLowerCase() === "delivery" ||
                opt.label.toLowerCase() === "delivery",
            );
            if (deliveryOption) cartTypeOption = deliveryOption;
          }
        }
      } else {
        // No cart type in API response - leave it empty (null)
        console.log(
          "No cart type in API response, leaving empty for user to assign",
        );
        cartTypeOption = null;
      }

      // console.log("Selected cart type option:", cartTypeOption);
      setValue("cartType", cartTypeOption); // This will be null if no cart type in API

      setValue("address", cartData.address || "");
      setValue("latitude", cartData.location?._latitude || 0);
      setValue("longitude", cartData.location?._longitude || 0);

      if (
        cartData.supportedChannels &&
        Array.isArray(cartData.supportedChannels)
      ) {
        const channelOptions = cartData.supportedChannels
          .map((channelValue: string) => {
            const option = SUPPORTED_CHANNELS_OPTIONS.find(
              (opt) => opt.value === channelValue,
            );
            return option || { value: channelValue, label: channelValue };
          })
          .filter(
            (option: any): option is ChannelOption => option !== undefined,
          );
        setValue("supportedChannels", channelOptions);
      } else {
        setValue("supportedChannels", []);
      }

      setSelectedReason(cartData?.reasonForBeingOffline || null);

      if (cartData.location?._latitude && cartData.location?._longitude) {
        setSelectedLocation({
          latitude: cartData.location._latitude,
          longitude: cartData.location._longitude,
        });
      }
    }
  }, [cartData, setValue]);

  useEffect(() => {
    if (
      isEditMode &&
      cartType?.value?.type === "fixed" &&
      cartData?.deliveryCartsIds
    ) {
      const fetchAndSetDeliveryNames = async () => {
        try {
          const response = await getAllCartDetails(undefined).unwrap();
          let allCarts = response;

          if (response.items && Array.isArray(response.items)) {
            allCarts = response.items;
          } else if (Array.isArray(response)) {
            allCarts = response;
          }

          // Filter for delivery carts only
          const deliveryCarts = allCarts.filter(
            (cart: any) =>
              cart.isFixedLocation === false &&
              cart.cartType?.toLowerCase() === "delivery",
          );

          const cartIds = cartData.deliveryCartsIds || [];
          const names = getCartNamesByIds(cartIds, deliveryCarts);
          setDeliveryCartNames(names);
        } catch (error) {
          console.error("Failed to fetch carts for display:", error);
        }
      };

      fetchAndSetDeliveryNames();
    }
  }, [isEditMode, cartType, cartData, getAllCartDetails, getCartNamesByIds]);

  return (
    <>
      {isFetching ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "200px" }}
        >
          <Spinner animation="border" variant="primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <span className="ms-2">Loading cart details...</span>
        </div>
      ) : (
        <Form className="m-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex justify-content-end mb-3">
            <EditButtonComponent onClick={handleEdit} />
          </div>

          {/* Image Section */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Image</Label>
            </Col>
            <Col lg="8">
              <div className="d-flex align-items-center">
                <img
                  src={cartData?.imageUrl || cart.imageUrl}
                  alt="cartimage"
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "300px",
                    objectFit: "cover",
                  }}
                />
                {!isEditMode && (
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={handleUpdatePhoto}
                    style={{ marginLeft: "-20px" }}
                    title="Edit Photo"
                  >
                    <FontAwesomeIcon icon={faEdit} />
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <hr />

          {/* Display Name */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Name</Label>
            </Col>
            <Col lg="8">
              <Controller
                name="displayName"
                control={control}
                rules={{ required: "Display name is required" }}
                render={({ field }) => (
                  <Input
                    {...field}
                    disabled={isEditMode}
                    invalid={errors.displayName ? true : false}
                    placeholder="Enter cart name"
                  />
                )}
              />
              {errors.displayName && (
                <div className="text-danger small mt-1">
                  {errors.displayName.message}
                </div>
              )}
            </Col>
          </Row>
          <hr />

          {/* Abbreviation */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Abbreviation</Label>
            </Col>
            <Col lg="8">
              <Controller
                name="abbreviation"
                control={control}
                render={({ field }) => (
                  <Input
                    {...field}
                    disabled={isEditMode}
                    placeholder="Enter abbreviation (optional)"
                  />
                )}
              />
            </Col>
          </Row>
          <hr />

          {/* Supported Channels */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Supported Channels</Label>
            </Col>
            <Col lg="8">
              {isEditMode ? (
                <div className="mt-1">
                  {cartData?.supportedChannels &&
                  cartData.supportedChannels.length > 0 ? (
                    cartData.supportedChannels.map(
                      (channel: string, index: number) => (
                        <span
                          key={index}
                          className="badge bg-primary me-1 mb-1"
                        >
                          {SUPPORTED_CHANNELS_OPTIONS.find(
                            (opt) => opt.value === channel,
                          )?.label || channel}
                        </span>
                      ),
                    )
                  ) : (
                    <span className="text-muted">No channels selected</span>
                  )}
                </div>
              ) : (
                <ControlledSelect
                  label=""
                  inputName="supportedChannels"
                  control={control}
                  optionsList={SUPPORTED_CHANNELS_OPTIONS}
                  placeholder="Select supported channels"
                  isMulti={true}
                  isClear={true}
                />
              )}
            </Col>
          </Row>
          <hr />

          {/* Cart ID */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Cart ID</Label>
            </Col>
            <Col lg="8" className="d-flex align-items-center">
              <span className="font-monospace">{cartData?.id || cartId}</span>
              {(cartData?.id || cartId) && (
                <Button
                  className="btn btn-outline-primary cartId-copy-button ms-2"
                  size="sm"
                  title="Copy Cart ID"
                  onClick={handleCopyToClipboard}
                >
                  <FontAwesomeIcon icon={faCopy} className="cartId-copy-icon" />
                </Button>
              )}
            </Col>
          </Row>
          <hr />

          {/* Cart Type */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Cart Type</Label>
            </Col>
            <Col lg="8">
              {isEditMode ? (
                <span className="fw-semibold">
                  {(() => {
                    const cartTypeValue = cartData?.cartType || cartData?.type;

                    // Show only if explicitly set in API
                    if (cartTypeValue) {
                      if (
                        cartTypeValue === "fixed" ||
                        cartTypeValue === "Fixed"
                      )
                        return "Fixed";
                      if (
                        cartTypeValue === "moving" ||
                        cartTypeValue === "Moving"
                      )
                        return "Moving";
                      if (
                        cartTypeValue === "delivery" ||
                        cartTypeValue === "Delivery"
                      )
                        return "Delivery";
                    }

                    // If no cart type in API, show placeholder
                    return <span className="text-muted">Not assigned</span>;
                  })()}
                </span>
              ) : (
                <ControlledSelect
                  label=""
                  inputName="cartType"
                  control={control}
                  optionsList={CART_TYPE}
                  rules={{ required: "Please select cart type." }}
                  errors={errors}
                  placeholder="Select cart type"
                  isClear={false}
                />
              )}
            </Col>
          </Row>
          <hr />

          {/* Delivery Carts Selection (only shown for fixed carts in edit mode) */}
          {!isEditMode && cartType?.value?.type === "fixed" && (
            <>
              <Row className="mb-3">
                <Col lg="4" className="cart-search-label-col">
                  <Label>Select Delivery Carts</Label>
                  <div className="small text-muted">
                    Select delivery carts that this fixed cart will manage
                  </div>
                </Col>
                <Col lg="8">
                  <ControlledSelect
                    label=""
                    inputName="deliveryCartsIds"
                    control={control}
                    optionsList={deliveryCartOptions}
                    errors={errors}
                    placeholder={
                      isLoadingDeliveryCarts
                        ? "Loading delivery carts..."
                        : isCartsLoading
                          ? "Loading..."
                          : deliveryCartOptions.length === 0
                            ? "No delivery carts available"
                            : "Select delivery carts"
                    }
                    isMulti={true}
                    isClear={true}
                    isDisabled={isLoadingDeliveryCarts || isCartsLoading}
                  />
                  {isLoadingDeliveryCarts || isCartsLoading ? (
                    <div className="text-muted small mt-1">
                      <FontAwesomeIcon icon={faSpinner} spin /> Loading delivery
                      carts...
                    </div>
                  ) : selectedDeliveryCartsIds &&
                    selectedDeliveryCartsIds.length > 0 ? (
                    <div className="text-success small mt-1">
                      {selectedDeliveryCartsIds.length} cart(s) selected
                    </div>
                  ) : deliveryCartOptions.length === 0 ? (
                    <div className="text-muted small mt-1">
                      No delivery carts available to assign
                    </div>
                  ) : null}
                </Col>
              </Row>
              <hr />
            </>
          )}

          {/* Display selected delivery carts in view mode (only for fixed carts) */}
          {isEditMode &&
            cartType?.value?.type === "fixed" &&
            deliveryCartNames.length > 0 && (
              <>
                <Row className="mb-3">
                  <Col lg="4" className="cart-search-label-col">
                    <Label>Assigned Delivery Carts</Label>
                  </Col>
                  <Col lg="8">
                    <div className="mt-1">
                      {deliveryCartNames.map((name: string, index: number) => (
                        <span key={index} className="badge bg-info me-1 mb-1">
                          {name}
                        </span>
                      ))}
                      <div className="text-muted small mt-1">
                        ({deliveryCartNames.length} cart(s) assigned)
                      </div>
                    </div>
                  </Col>
                </Row>
                <hr />
              </>
            )}

          {/* Location Section */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Cart Location</Label>
            </Col>
            <Col lg="8">
              {isFixedCart ? (
                <div>
                  <p className="mb-2">
                    {cartData?.address || "No address available"}
                  </p>
                  <LiveLocationMap
                    latitude={
                      cartData?.location?._latitude || selectedLocation.latitude
                    }
                    longitude={
                      cartData?.location?._longitude ||
                      selectedLocation.longitude
                    }
                  />
                </div>
              ) : (
                <p className="text-muted">
                  {cartType ? (
                    <>
                      This is a{" "}
                      {cartType?.value?.type === "moving"
                        ? "Moving"
                        : "Delivery"}{" "}
                      cart and does not have a fixed location.
                    </>
                  ) : (
                    "Cart type not assigned yet."
                  )}
                </p>
              )}

              {!isEditMode && isFixedCart && (
                <>
                  {/* Address Section (only shown for fixed location carts) */}
                  <ControlledRowTextFieldAddress
                    label="Address"
                    inputName="address"
                    inputType="text"
                    placeholder="Select Address From Location Button"
                    control={control}
                    setShowModal={setMapShowModal}
                    rules={{ required: "Please enter an address" }}
                    errors={errors}
                  />

                  {/* Hidden Location Fields */}
                  <Row className="d-none">
                    <Col lg="5">
                      <ControlledRowTextField
                        label="Latitude"
                        inputName="latitude"
                        inputType="number"
                        placeholder="Enter Latitude"
                        isRequired={true}
                        control={control}
                        isDisabled={true}
                      />
                    </Col>
                    <Col lg="5">
                      <ControlledRowTextField
                        label="Longitude"
                        inputName="longitude"
                        inputType="number"
                        placeholder="Enter Longitude"
                        isRequired={true}
                        control={control}
                        isDisabled={true}
                      />
                    </Col>
                    <Col lg="2">
                      <ButtonComponent
                        icon={<FontAwesomeIcon icon={faMapMarkerAlt} />}
                        type="button"
                        onClick={() => setMapShowModal(true)}
                      />
                    </Col>
                  </Row>
                </>
              )}
            </Col>
          </Row>
          <hr />

          {/* Created At */}
          <Row className="mb-3">
            <Col lg="4" className="cart-search-label-col">
              <Label>Created At</Label>
            </Col>
            <Col lg="8">{formatTimestamp(cartData?.createdAt)}</Col>
          </Row>

          {/* Action Buttons */}
          <Row className="mt-4 cart-details-edit-position">
            <Col lg="12" className="d-flex justify-content-end gap-2">
              {/* Status Buttons */}
              {cartData?.cartState === "offline" ||
              cartData?.cartState === "Offline" ? (
                <>
                  <ButtonComponentV2
                    titel="Go Online"
                    color="#fff"
                    backgroundColor="#198754"
                    size="medium"
                    onClick={handleUpdateCartStatusBackOnline}
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                  />
                  <ButtonComponentV2
                    titel="On The Way"
                    color="#212529"
                    backgroundColor="#ffc107"
                    size="medium"
                    onClick={handleUpdateCartStatusOntheWay}
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                  />
                </>
              ) : cartData?.cartState === "onTheWay" ||
                cartData?.cartState === "OnTheWay" ? (
                <>
                  <ButtonComponentV2
                    titel="Go Online"
                    color="#fff"
                    backgroundColor="#198754"
                    size="medium"
                    onClick={handleUpdateCartStatusBackOnline}
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                  />
                  <ButtonComponentV2
                    titel="Go Offline"
                    color="#fff"
                    backgroundColor="#DC3545"
                    size="medium"
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                    onClick={handleOffline}
                  />
                </>
              ) : cartData?.cartState === "Online" ||
                cartData?.cartState === "online" ? (
                <>
                  <ButtonComponentV2
                    titel="On The Way"
                    color="#212529"
                    backgroundColor="#ffc107"
                    size="medium"
                    onClick={handleUpdateCartStatusOntheWay}
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                  />
                  <ButtonComponentV2
                    titel="Go Offline"
                    color="#fff"
                    backgroundColor="#DC3545"
                    size="medium"
                    isDisabled={cartData?.status !== "Approved" || isEditMode}
                    onClick={handleOffline}
                  />
                </>
              ) : (
                <ButtonComponentV2
                  titel="Go Offline"
                  color="#fff"
                  backgroundColor="#DC3545"
                  size="medium"
                  isDisabled={cartData?.status !== "Approved" || isEditMode}
                  onClick={handleOffline}
                />
              )}

              {/* Save Button */}
              {isLoading ? (
                <ButtonComponentV2
                  titel="Saving..."
                  icon={<FontAwesomeIcon icon={faSpinner} spin />}
                  isDisabled={true}
                  backgroundColor="#590B21"
                />
              ) : (
                <ButtonComponentV2
                  titel="Save"
                  icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                  onClick={handleSubmit(onSubmit)}
                  backgroundColor="#590B21"
                  isDisabled={isEditMode}
                />
              )}
            </Col>
          </Row>

          {/* Change Status Button */}
          <Row className="mt-3 cart-details-edit-position">
            <Col lg="12" className="d-flex justify-content-end">
              <ButtonComponentV2
                titel="Change Status"
                color="#212529"
                backgroundColor="#FFC107"
                size="medium"
                onClick={handleStatusUpdateShowModal}
                isDisabled={isEditMode}
              />
            </Col>
          </Row>
        </Form>
      )}

      {/* Update Photo Modal */}
      <Modal show={showModal} onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Update Cart Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditPhotoUpload
            imageUrl={uploadedImgDetails.imgSrc}
            onUpload={imageUploadCallback}
          />
        </Modal.Body>
        <Modal.Footer>
          {isImageUpdateLoading ? (
            <ButtonComponent
              titel="Saving..."
              icon={<FontAwesomeIcon icon={faSpinner} spin />}
              isDisabled={true}
            />
          ) : (
            <ButtonComponent
              titel="Save"
              onClick={handleCartImageUpdate}
              isDisabled={isSaveButtonDisabled || isImageUpdateLoading}
              icon={<FontAwesomeIcon icon={faFloppyDisk} />}
            />
          )}
        </Modal.Footer>
      </Modal>

      {/* Go Offline Modal */}
      <Modal show={showModalOffline} onHide={handleCloseOfflineModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reason For Going Offline</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {REASONS_FOR_GO_OFFLINE.map((reasonForBeingOffline, index) => (
            <Form.Check
              type="radio"
              id={`reason-${index}`}
              name="goOfflineReason"
              value={reasonForBeingOffline}
              label={reasonForBeingOffline}
              onChange={handleInputCartOnlineChange}
              checked={selectedReason === reasonForBeingOffline}
              key={index}
              className="mb-2"
            />
          ))}
          {selectedReason === "Other" && (
            <Form.Group className="mt-3">
              <Form.Control
                type="text"
                placeholder="Enter your reason"
                value={otherReasonText}
                onChange={(e) => setOtherReasonText(e.target.value)}
                isInvalid={
                  selectedReason === "Other" && !otherReasonText.trim()
                }
                required
              />
              <Form.Control.Feedback type="invalid">
                Please enter a reason.
              </Form.Control.Feedback>
            </Form.Group>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseOfflineModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleUpdateCartStatusOnline}
            disabled={
              !selectedReason ||
              (selectedReason === "Other" && !otherReasonText.trim())
            }
          >
            Go Offline
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Change Status Modal */}
      <Modal
        show={showStatusUpdateModal}
        onHide={handleCloseStatusUpdateModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Change Cart Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-between gap-2 flex-wrap">
            {cartData?.status === "Pending" ? (
              <>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="danger"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="success"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
              </>
            ) : cartData?.status === "Approved" ? (
              <>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="danger"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="warning"
                  onClick={() => handleStatusUpdate("Deleted", "delete")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "delete" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faWarning} className="me-2" />
                  )}
                  Delete
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="info"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
              </>
            ) : cartData?.status === "Deleted" ? (
              <>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="success"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="info"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="danger"
                  onClick={() => handleStatusUpdate("Rejected", "reject")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "reject" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faClose} className="me-2" />
                  )}
                  Reject
                </Button>
              </>
            ) : cartData?.status === "Rejected" ? (
              <>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="success"
                  onClick={() => handleStatusUpdate("Approved", "approve")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "approve" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faCheck} className="me-2" />
                  )}
                  Approve
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="info"
                  onClick={() => handleStatusUpdate("Pending", "pending")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "pending" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faQuestion} className="me-2" />
                  )}
                  Pending
                </Button>
                <Button
                  className="change-status-btn flex-fill mb-2"
                  variant="warning"
                  onClick={() => handleStatusUpdate("Deleted", "delete")}
                  disabled={isCartStautsUpdating}
                >
                  {isCartStautsUpdating && clickedButton === "delete" ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                  ) : (
                    <FontAwesomeIcon icon={faWarning} className="me-2" />
                  )}
                  Delete
                </Button>
              </>
            ) : (
              <div className="text-center w-100">
                No status actions available
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseStatusUpdateModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Location Selector Modal */}
      <Modal
        show={mapShowModal}
        onHide={() => setMapShowModal(false)}
        centered
        size="lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Cart Location</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Map onSaveLocation={handleLocationSave} />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMapShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              // You can add validation here if needed
              setMapShowModal(false);
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CartDetails;
